import BlazeSlider from 'blaze-slider'
import 'blaze-slider/dist/blaze.css'

document.querySelectorAll('.element-testimonials').forEach((el) => {
  const slider = el.querySelector('.blaze-slider')
  const numSlides = slider.querySelectorAll('.blaze-slide').length

  if (numSlides > 1) {
    new BlazeSlider(slider, {
      '(min-width: 1280px)': {
        slideGap: '40px',
      },
      '(min-width: 1536px)': {
        slideGap: '60px',
      },
    })
  }
})
